import { DOCUMENT } from '@angular/common';
import { ChangeDetectionStrategy, Component, ViewEncapsulation, inject, input, output } from '@angular/core';
import { SessionItem, SessionListComponent } from '@workbuddy/ui/v2/components/session.list';
import { DesignSystem } from '@workbuddy/ui/v2/design-system';
import { sessionLimitBlockBridgeStyles, sessionLimitBlockStyleId } from './session.limit.block.theme';

@Component({
  selector: 'wb-session-limit-block',
  imports: [SessionListComponent],
  templateUrl: './session.limit.block.html',
  styleUrls: ['./session.limit.block.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class SessionLimitBlockComponent {

  private readonly document = inject(DOCUMENT);

  public $sessions = input<SessionItem[]>([], { alias: 'sessions' });
  public $limit = input<number>(2, { alias: 'limit' });
  public $title = input<string>('Active session limit reached', { alias: 'title' });
  public $logoSrc = input<string>('/images/workbuddy_full_logo_blue.svg', { alias: 'logoSrc' });
  public $supportHref = input<string | null>(null, { alias: 'supportHref' });
  public $supportLabel = input<string>('See docs', { alias: 'supportLabel' });

  public endSession = output<SessionItem>();
  public endAll = output<void>();
  public tryAgain = output<void>();

  constructor() {

    DesignSystem.Mount(this.document, sessionLimitBlockStyleId, sessionLimitBlockBridgeStyles);
  }
}
